import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="error">
    <h1>Oooops - Not Found!</h1>
    <Link to="/">
      Go Home
    </Link>
  </div>
);

export default NotFound;